<template>
  <div class="activity-register" v-if="selected !== -1">
    <div class="caption">
      <div class="title-task">
        <i class="icon-dailytask_1"></i>
        <div class="label-box">
          <div class="bg"></div>
          <span class="label-shadow">每日任务</span>
          <span class="label-text">每日任务</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="item" v-for="(value, index) in data[0]" :key="index">
        <div class="item-wrap">
          <div class="item-left">
            <div class="item-icon">
              <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
              <div class="tip">
                <div class="label-box">
                  <span class="label-shadow">{{ value.coins }}</span>
                  <span class="label-text">{{ value.coins }}</span>
                </div>
              </div>
            </div>
            <div class="desc">
              {{ value.title }}
            </div>
          </div>

          <div class="item-right">
            <span class="time-target"
              >({{ value.progress }} / {{ value.progressTotal }})</span
            >
            <button
              class="button-status"
              :class="classMode[value.status]"
              @click="handleStatusClick(value.status, value, index ,type=true)"
            >
              <ui-frame-bg :colorType="colorMode[value.status]">
                <div class="label-box">
                  <span class="label-shadow">{{ statusMode[value.status] }}</span>
                  <span class="label-text">{{ statusMode[value.status] }}</span>
                </div>
              </ui-frame-bg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="line"></div> -->
    
    <div class="cumulative" :class="{ None_DataTaskII: filteredDataTaskII.length == 0}">
      <div class="content DataTaskI1">
        <div class="title-task">
          <i class="icon-addtask1_1"></i>
          <div class="label-box">
            <div class="bg"></div>
            <span class="label-shadow">累计任务一</span>
            <span class="label-text">累计任务一</span>
          </div>
        </div>
        <div class="item" v-for="(value, index) in filteredDataTaskI1" :key="value.id">
          <div class="item-wrap">
            <div class="item-left">
              <div class="item-icon bg">
                <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
                <div class="tip">
                  <div class="label-box">
                    <span class="label-shadow">{{ value.coins }}</span>
                    <span class="label-text">{{ value.coins }}</span>
                  </div>
                </div>
              </div>
              <div class="desc">
                {{ value.title }}
              </div>
            </div>

            <div class="item-right">
              <span class="time-target"
                >({{ value.progress }} / {{ value.progressTotal }})</span
              >
              <button
                class="button-status"
                :class="classMode[value.status]"
                @click="handleStatusClick(value.status, value, index,type=false)"
              >
                <ui-frame-bg :colorType="colorMode[value.status]">
                  <div class="label-box">
                    <span class="label-shadow">{{ statusMode[value.status] }}</span>
                    <span class="label-text">{{ statusMode[value.status] }}</span>
                  </div>
                </ui-frame-bg>
              </button>
            </div>
          </div>
          <div :class="{'item-line':index < data[1].length - 2}"></div>
        </div>
      </div>
      <div class="content DataTaskII">
        <div class="title-task">
          <i class="icon-addtask2_1"></i>
          <div class="label-box">
            <div class="bg"></div>
            <span class="label-shadow">累计任务二</span>
            <span class="label-text">累计任务二</span>
          </div>
        </div>
        <div class="item" v-for="(value, index) in filteredDataTaskII" :key="value.id">
          <div class="item-wrap">
            <div class="item-left">
              <div class="item-icon bg">
                <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
                <div class="tip">
                  <div class="label-box">
                    <span class="label-shadow">{{ value.coins }}</span>
                    <span class="label-text">{{ value.coins }}</span>
                  </div>
                </div>
              </div>
              <div class="desc">
                {{ value.title }}
              </div>
            </div>

            <div class="item-right">
              <span class="time-target"
                >({{ value.progress }} / {{ value.progressTotal }})</span
              >
              <button
                class="button-status"
                :class="classMode[value.status]"
                @click="handleStatusClick(value.status, value, index,type=false)"
              >
                {{ statusMode[value.status] }}
              </button>
              </div>
            </div>
        <div :class="{'item-line':index < data[1].length - 2}"></div>
        </div>
      </div>
    </div>
    
    <!-- <div class="dashed-line"></div> -->
  </div>
</template>

<script>

import { mapState } from "vuex";
import * as api from "@/service/index";
import uiFrameBg from '@/components/ui-frame-bg'

export default {  
  components: {
    uiFrameBg
  },
  data() {
    return {
      classMode: ['undone', 'receive', 'received'],
      statusMode: ['未完成', '领取', '已领取'],
      colorMode: ['gray-light', 'yellow', 'gray'],
      padlock :false,
      countdown: '加载中...',
    }
  },
  props: {
    data: Array,
    selected: Number
  },
  computed: {
    ...mapState(['amount', 'token','isInterdict']),
     filteredDataTaskI1() {
      // 先检查 data 是否存在，防止 undefined 错误
      if (!this.data[1] || this.data[1].length === 0) {
        return [];
      }

      return this.data[1].filter(item => {
        let items = parseInt(item.id.slice(4));  // 提取 "task" 后的数字
        return items >= 4 && items <= 12;
      });
    },
    filteredDataTaskII() {
      // 先检查 data 是否存在，防止 undefined 错误
      if (!this.data[1] || this.data[1].length === 0) {
        return [];
      }

      return this.data[1].filter(item => {
        let taskNumber = parseInt(item.id.slice(4));  // 提取 "task" 后的数字
        return taskNumber >= 13 && taskNumber <= 19;
      });
    }
  },
  watch: {
    'countdown': {
      handler() {
        // this.formatCountdown()
      },
      immediate: true
    }
  },
  methods: {
    handleStatusClick(status,value,index,type) {
      // console.log('value',value)
      if(!this.padlock){
        this.padlock = true
        if(status === 1){
          if(type){
            // const dataIndex = type ? 0 : 1;
            this.data[0][index].status = 2
          }else{
            let itemindex =  this.data[1].findIndex(item => item.id === value.id );
            this.data[1][itemindex].status = 2
          }
        }
        this.$emit('statusClick', status, value, type)
        // 埋点 
        this.padlock = false
      }
    },
    async formatCountdown() {
      try {
        const  now = await api.reqcurrentTime()
        if(now.status == 200){
          const targetTime = this.amount.part2StartTime * 1000;
          // console.log('targetTime',targetTime);
      
          const currentTime = new Date(now.data).getTime();
          // console.log('currentTime',currentTime);
          const timeDifference = targetTime - currentTime;

          if (timeDifference <= 0) {
            this.countdown = 0 
            return
          }
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // 计算剩余天数
          const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算剩余小时
        

          this.countdown =   `${days}日${hours}时`;
          // console.log('countdown',this.countdown)
        }
      }catch(err){
        console.log(err)
      }
    },
  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/activity/register';
</style>